import React from 'react';
import { TankEta } from '../../store/EtaSlice';
import Card from './EtaCard';
import classes from './EtaTank.module.css';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

interface EtaTankProps {
    tanks: TankEta[],
    maxValue: number
}

const EtaTank = (props: EtaTankProps) => {
    const { t, i18n } = useTranslation();

    const getHeight = (vol: number) => {
        if (props.maxValue > 0) {
            return Math.round((vol / props.maxValue) * 100) + '%';
        }
        else
            return '0%';
    }

    return (
        <div className="col justify-content-center">
            {
                props.tanks.map((tnk: TankEta) => {
                    return (
                        <Card key={tnk.tankNumber}>
                            <div className="row">
                                <div className="col-xs-5 ml-2">
                                    <div className={classes.chart}>
                                        <div className={classes.chartBar}>
                                            <div className={classes.chartBarInner}>
                                                <div className={classes.chartBarFill}
                                                    style={{ height: getHeight(tnk.volume) }}>
                                                </div>
                                                <div className={classes.chartBarText}>
                                                    {tnk.tankNumber}
                                                </div>
                                            </div>
                                            <div className={classes.chartBarLabel}>{tnk.productClass2}</div>
                                        </div>

                                    </div>

                                </div>
                                <div className="col-xs-7 ml-1 mt-2">
                                    <div className="row p-0">
                                        <div className="col-xs-3 pt-0 pb-0 ml-3 pl-1">
                                            <span className={classes.tankTopText}>{tnk.tankVolume} <br /></span>
                                            <span className={classes.tankBottomText}>{tnk.shutDownVolume}</span>
                                        </div>
                                        <div className={"col-xs-1 ml-3 mt-2 " + classes.verticalLine}>
                                            &nbsp;
                                        </div>
                                        <div className="col-xs-8 ml-2">
                                            <div className={classes.volLabelText + " mb-1 mt-3"}>Current Volume</div>
                                            <div className={classes.volText + " mb-1"}>{tnk.volume}</div>
                                            <div className={classes.volLabelText + " mb-1"}>At</div>
                                        <div className={classes.volWrapperText + " mb-1"}>{moment(tnk.inventoryDate).format(t('dateTimeFormat'))}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    )
                })
            }
        </div>
    );
};

export default EtaTank;